import styled from "styled-components";
import Landing from "../../assets/icons/LandingPage.png";

export const Container = styled.div`
  background-image: url("/assets/icons/LandingPage.jpg");
  display: flex;
  align-items: center;
  background-size: cover;
  flex-direction: column;
`;

export const PriceContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 0;
  padding-top: 40px;
  padding-bottom: 120px;
`;
export const PriceContentWrapper = styled.div``;
export const SpanH1 = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 60px;
  font-weight: 700;
  line-height: 78px;
  letter-spacing: 0.5px;
  text-align: center;
  margin-bottom: 0px;
  color: #09005b;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 30px;
    line-height: 34.35px;
  }
`;
export const SpanP1 = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #5e5e5e;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 16px;
    line-height: 24px;
  }
`;
export const PriceContainerCards = styled.div`
  display: flex;
  width: 100%;
  /* border: 1px solid #ec0e0e; */
  justify-content: center;
  align-items: center;
`;
export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    flex-direction: column;
  }
`;
export const Card = styled.div`
  flex: 1;
  margin: 20px;
  padding: 20px;
  max-width: 476px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  position: relative;
  box-shadow: 0px 4px 50px 0px #d4d0c54a;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    border-radius: 5px;
    background-color: #008502;
    clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 100%);
  }
`;
export const CardTitle = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #363636;
`;
export const CardPrice = styled.h3`
  font-family: GT Walsheim Pro;
  font-size: 38px;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #09005b;
  margin-bottom: 0px;
  margin-top: 0px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 30px;
    line-height: 34.35px;
  }
`;
export const CardDescription = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
  display: flex;
  /* align-items: center; */

  gap: 10px;
  span {
    display: flex;
    align-items: center;
  }

  span > svg {
    background-color: #00c7031a;
    padding: 3px;
    border-radius: 50%;
    color: #00c703;
  }
`;
export const CardButton = styled.button<{ primary?: boolean }>`
  display: flex;
  width: 155px;
  height: 44px;
  padding: 24px;
  border: none;
  border-radius: 30px;
  justify-content: center;
  color: white;
  align-items: center;
  gap: 8px;
  background-color: ${(props) => (props.primary ? "green" : "transparent")};
`;

export const CardButtonOutline = styled(CardButton)`
  background-color: transparent;
  border: 1px solid #00a603;
  color: #00a603;
  justify-content: center;
  display: flex;
  align-items: center;
`;
